import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="transaccion--pago"
export default class extends Controller {
  static targets = ["pantalla"] 
  static values = {
    nombreEmpresa: String,
    origen: String,
  }

  connect() {
    this.tipo_servicio = ""
    this.categoria = ""
    this.servicio = ""
    this.servicio_id = ""
    this.nivel = ""
    this.renderCategorias()
  }

  // 1. Listar las categorias de Servicio
  renderCategorias() {
    window.mostrar_animacion();
    this.cargar_logo();

    this.pantallaTarget.innerHTML = `<h2 class="screen-title">Selecciona una categoria</h2>
    <p class="screen-subtitle">Ingresa al módulo deseado para continuar.</p>`

    fetch(`/servicios/servicio_categorias`, {
      method: "GET",
      headers: this.jsonHeaders()
    })
    .then(response => response.json())
    .then(data => {
      // console.log("Respuesta Servicio Categorias:", data)
      if (!data.estado) {   
        this.pantallaTarget.innerHTML += `<p>Sin servicios</p>`
      }

      let categorias = data.data;
      categorias.forEach((categoria, index) => {
        this.pantallaTarget.innerHTML += ` 
          <div class="list-group">
            <button class="list-group-item card mb-3" style="border-radius: var(--radius-md);" data-action="click->transaccion--pago#renderServicios" data-tipo_servicio="servicio" data-categoria="${categoria.id}">
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div class="icon-badge">
                  <img src="${categoria.icon}" alt="${categoria.nombre}" style="width:28px; height: 28px; object-fit: contain; filter: grayscale(1) brightness(100);">
                </div>
                
                <p class="mb-0">${categoria.nombre}</p>
              </div>
            </button>
          </div>
        `
      });

      window.quitar_animacion();
    })
    .catch(error => {
      // console.error("Error:", error)
      this.alert_error(error);

      // button.disabled = false
      // button.innerText = "Convocar Repartidores"
    })
  }


  // 2. Listar los Servicios
  renderServicios(e) {
    window.mostrar_animacion();

    this.categoria = e.currentTarget.dataset.categoria
    // console.log("Categoria:"+this.categoria);

    this.pantallaTarget.innerHTML = `
      <h2 class="screen-title">Selecciona un servicio</h2>
      <p class="screen-subtitle mb-5">Ingresa al módulo deseado para continuar.</p>
    `

    fetch(`/servicios/servicio_tipos?categoria=${this.categoria}`, {
      method: "GET",
      headers: this.jsonHeaders()
    })
    .then(response => response.json())
    .then(data => {
      // console.log("Respuesta Servicios Tipos:", data)
      window.quitar_animacion();

      if (!data.estado) {   
        this.pantallaTarget.innerHTML += `<p>Sin servicios</p>`
      }

      // Renderizar catalogo
      let servicios = data.data;
      servicios.forEach((servicio, index) => {
        let servicio_categoria = servicio.servicio_categoria

        this.pantallaTarget.innerHTML += ` 
          <div class="list-group">
            <button class="list-group-item card mb-3" style="border-radius: var(--radius-md);" 
              data-action="click->transaccion--pago#renderFormulario" data-tipo_servicio="servicio" data-categoria="${this.categoria}" 
              data-servicio_id="${servicio.id}" data-nivel="${servicio.nivel_servicio}"
              data-servicio="${servicio.name}"
            >
              <div class="d-flex justify-content-start align-items-center gap-3">
                <div class="icon-badge">
                  <img src="${servicio_categoria.icon}" alt="${servicio.name}" style="width:28px; height: 28px; object-fit: contain;">
                </div>

                <div class="d-flex flex-column justify-content-center align-items-start" style="width: 200px;">
                  <h4>${servicio.name}</h4>
                  <p class="m-0" style="font-size: 12px;">${servicio.description}</p>
                </div>
              </div
            </button>
          </div>
        `
      });
      
      // Botonera
      this.pantallaTarget.innerHTML += `<div class="d-flex justify-content-between mt-5">
        <button class="btn btn-secondary" data-action="click->transaccion--pago#renderCategorias">← Regresar</button>
        <button class="btn btn-ghost" data-action="click->transaccion--pago#cancelar">Cancelar</button>
      </div>`
      
    })
    .catch(error => {
      // console.error("Error:", error)
      
      window.quitar_animacion();
      
      this.alert_error(error);
      // button.disabled = false
      // button.innerText = "Convocar Repartidores"
    })
  }


  // 3. Renderizar el formulario segun Servicio, N1, N2
  async renderFormulario(e) {
    this.tipo_servicio = e.currentTarget.dataset.tipo_servicio
    this.categoria = e.currentTarget.dataset.categoria
    this.servicio = e.currentTarget.dataset.servicio
    this.servicio_id = e.currentTarget.dataset.servicio_id
    this.nivel = e.currentTarget.dataset.nivel
  
    this.schemaBase()
  
    if (this.nivel == "2") {      
      const fields = await this.formularioServicio()
      this.renderForm(fields, "continuarServicio")

    } else {
      const fields = await this.formularioConfirmacion()
      this.renderForm(fields, "submitFormulario")
    }
  }

  schemaBase() {
    this.schema = [
      { name: "tipo_servicio", type: "text", value: this.tipo_servicio, required: true, readonly: true, hidden: true },
      { name: "categoria", type: "text", value: this.categoria, required: true, readonly: true, hidden: true },
      { name: "servicio_id", type: "text", value: this.servicio_id, required: true, readonly: true, hidden: true },
      { name: "nivel", type: "text", value: this.nivel, required: true, readonly: true, hidden: true },
    ]
  }

  renderForm(fields, action) {
    fields.forEach(campo => {
      this.schema.push({
        name: campo.tag,
        label: campo.hint,
        type: campo.type_input,
        pattern: campo.regex,
        required: campo.required,
        value: campo.value,
        readonly: campo.readonly,
        has_option: campo.has_option,
        options: campo.options,
        hidden: campo.hidden,
      })
    })

    this.pantallaTarget.innerHTML = `
      <h2 class="screen-title">Formulario de servicio</h2>
      <p class="screen-subtitle mb-5">Completa el siguiente formulario.</p>
    `
  
    let camposHtml = this.schema.map(c => {

      // SI TIENE OPTIONS -> SELECT
      if (c.has_option && c.options && Object.keys(c.options).length > 0) {

        const optionsHtml = Object.values(c.options).map((opt, index) => {
          const id = `${c.name}_${index}`

          // hidden
          return `
            <div class="mb-3">
              <input 
                class="form-check-input"
                type="radio"
                name="payload[${c.name}]"
                id="${id}"
                value="${opt.id}"
                data-monto="${opt.value}"
                data-action="change->transaccion--pago#${action}"
                ${c.value == opt.id ? "checked" : ""}
                ${c.required ? "required" : ""}
                ${this.nivel == "1" ? "disabled" : ""}
                hidden
              />
              
              <label class="form-check-label w-100" for="${id}">
                <div class="card">
                  ${opt.description}
                </div>
              </label>
            </div>
          `
        }).join("")


        return `
          <div class="mb-2 card-info-options" data-field="${c.name}">
            <label>${(c.label || c.name).replaceAll("_", " ")}</label>
      
            <div class="mt-2 card-content">
              ${optionsHtml}
            </div
      
            <div class="invalid-feedback"></div>
          </div>
        `
      }
    

      // INPUT HIDDEN
      if (c.hidden) {
        return `
          <input
            type="hidden"
            name="payload[${c.name}]"
            value="${c.value || ""}"
          />
        `
      }


      // SI NO -> INPUT NORMAL
      let ocultar = (c.name == "dblCashAmount" && this.nivel == "1") ? `hidden` : ""
      return `
        <div class="mb-2" data-field="${c.name}">
          <label ${ocultar}>${(c.label || c.name).replaceAll("_", " ")}</label>
    
          <input class="form-control"
            name="payload[${c.name}]"
            type="${c.type || "text"}"
            ${c.required ? "required" : ""}
            ${c.pattern ? `pattern="${c.pattern}"` : ""}
            ${c.value ? `value="${c.value}"` : ""}
            ${c.readonly ? `readonly="${c.readonly}"` : ""}

            ${ocultar}
            ${(c.name == "strPan" && this.nivel == "1") ? `data-action="input->transaccion--pago#habilitarRadios"` : ""}

            ${(c.name == "strPan" && this.nivel == "2") ? `data-action="change->transaccion--pago#${action}"` : ""}
          />
    
          <div class="invalid-feedback"></div>
        </div>
      `
    }).join("")

    // Mostrar Boton de continuar solo si es nivel 2
    if (this.nivel == "2"){
      camposHtml += ` 
        <button id="btn-continuar" class="btn btn-primary w-100 my-3">Continuar</button>
      `
    }


    this.pantallaTarget.innerHTML += `
      <form id="form-principal" class="form-card" onsubmit="return false;">
        <input type="hidden" name="origen" value="${this.origenValue.toUpperCase()}"/>

        ${camposHtml}
      </form>
      
      <div id="resultado-dinamico"></div>
    `
  
    /*this.pantallaTarget.innerHTML += `
      <form data-action="submit->transaccion--pago#${action}">
        ${camposHtml}
        <button class="btn btn-primary w-100 my-3">Continuar</button>
      </form>
    ` */

    // Botonera
    this.pantallaTarget.innerHTML += `
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-secondary" data-action="click->transaccion--pago#renderServicios" data-tipo_servicio="servicio" data-categoria="${this.categoria}" data-servicio_id="${this.servicio_id}" data-nivel="${this.nivel}">← Regresar</button>
        <button class="btn btn-ghost" data-action="click->transaccion--pago#cancelar">Cancelar</button>
      </div>
    `
  }
  
  
  // Nivel 1
  async formularioConfirmacion() {
    try {
      window.mostrar_animacion();

      const res = await fetch(`/servicios/get_formulario_confirmacion?servicio=${this.servicio_id}`, {
        headers: this.jsonHeaders()
      })
  
      const data = await res.json()
      // console.log("Respuesta Formulario Confirmacion:", data)
      window.quitar_animacion();

      if (data.estado) {
        return data.data.formulario.fields
      }
  
      return []
    } catch (error) {
      console.error(error)
      return []
    }
  }

  habilitarRadios(e) {
    const value = e.target.value.trim()
    const form = e.target.closest("form")
    const radios = form.querySelectorAll('input[type="radio"]')

    radios.forEach(radio => {
      radio.disabled = value === ""
    })
  }



  // Nivel 2
  async formularioServicio() {
    try {
      window.mostrar_animacion();

      const res = await fetch(`/servicios/get_formulario_servicio?servicio=${this.servicio_id}`, {
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const data = await res.json()
      // console.log("Respuesta Formulario Servicio:", data)
      window.quitar_animacion();

      if (data.estado) {
        return data.data.formulario.fields
      }

      return []

    } catch (error) {
      console.error(error)
      return []
    }
  }


  async continuarServicio(e) {
    e.preventDefault()
  
    const form = e.target.closest("form")
    const payload = this.buildPayload(form)

    // Evitar requests mientras escribe
    if (this.loadingConsulta) return
    this.loadingConsulta = true

    try{
      const tx = await this.crearTransaccion_n2(payload)
      if (!tx) return
    
      this.transaccionId = tx.identificador
      const data = await this.consultarServicio(payload, this.transaccionId)
      if (!data) return
    
      // Body
      const form_confirmacion = data.data?.form_confirmacion || {}
      let body = {
        transaccion: {
          respuesta_rxe_servicio_consulta: data,
          estado: 1,
          monto_total: form_confirmacion["dblCashAmount"] || form_confirmacion["dblTotalAmount"],
          payload: form_confirmacion
        }
      }

      const respuestaUpdate = await this.actualizarTransaccion(this.transaccionId, body)
      // Validar estado update
    
      const confirmFields = await this.formularioConfirmacion()
      this.mapearConfirmacion(confirmFields, data)

      this.renderResultadoDinamico(respuestaUpdate.data)

      this.bloquearBusqueda(form)
    
    } finally {
      this.loadingConsulta = false
      
      if (this.nivel == "2") { 
        const btnContinuar = document.getElementById("btn-continuar");
        if (btnContinuar){
          btnContinuar.hidden = true;
        }
      }
    }
  }

  renderResultadoDinamico(data) {
    const container = this.pantallaTarget.querySelector("#resultado-dinamico")
    const { qr, referencia, nombre_servicio, fecha_operacion, monto_ingresado, moneda, ...otros } = data

    container.innerHTML = `
      <hr/>
      <h4>Confirmación</h4>

      <div class="form-card mb-3">
        <div class="d-flex justify-content-between" style="font-size: 20px;">
          <strong>Fecha:</strong> ${fecha_operacion}
        </div>

        <div class="d-flex justify-content-between" style="font-size: 20px;">
          <strong>Detalle:</strong> ${nombre_servicio}
        </div>

        <div class="d-flex justify-content-between" style="font-size: 20px;">
          <strong>Monto a pagar:</strong> ${moneda}.${monto_ingresado}
        </div>
      </div>

      <button class="btn btn-primary w-100 my-3" data-action="click->transaccion--pago#procesarTransaccion">
        Confirmar
      </button>
    `
  }

  /* renderResultadoDinamico(fields) {
    const container = this.pantallaTarget.querySelector("#resultado-dinamico")

    const html = fields.map(f => `
      <div class="form-card mb-2">
        <label>${f.hint}</label>
        <input class="form-control" value="${f.value}" readonly />
      </div>
    `).join("")

    container.innerHTML = `
      <hr/>
      <h4>Confirmación</h4>
      ${html}

      <button class="btn btn-primary w-100 my-3" data-action="click->transaccion--pago#procesarTransaccion">
        Confirmar
      </button>
    `
  } */


  buildPayload(form) {
    const fd = new FormData(form)
    const raw = Object.fromEntries(fd.entries())
  
    const payload = {}
  
    Object.entries(raw).forEach(([key, value]) => {
      if (key.startsWith("payload[")) {
        const clean = key.replace("payload[", "").replace("]", "")
        payload[clean] = value
      }
    })
  
    return payload
  }

  async crearTransaccion_n2(payload) {
    window.mostrar_animacion();

    const token = this.csrfToken()
  
    const res = await fetch("/transacciones", {
      method: "POST",
      headers: this.jsonHeaders(token),
      body: JSON.stringify({
        transaccion: {
          servicio_id: this.servicio_id,
          servicio: this.servicio,
          tipo_servicio: this.tipo_servicio,
          categoria: this.categoria,
          nivel: this.nivel,
          prefijo_empresa: this.nombreEmpresaValue.toUpperCase(),
          origen: this.origenValue.toUpperCase()
        }
      })
    })
  
    const json = await res.json()
    window.quitar_animacion();
  
    if (!json.estado) {
      // alert("Error creando transacción")

      this.alert_error("Error creando transacción");

      return null
    }
  
    return json.data
  }

  async consultarServicio(payload, identificador) {
    window.mostrar_animacion();

    const token = this.csrfToken()
  
    const res = await fetch("/servicios/get_informacion_servicio", {
      method: "POST",
      headers: this.jsonHeaders(token),
      body: JSON.stringify({
        servicio_id: this.servicio_id,
        identificador: identificador,
        form_data: payload
      })
    })
  
    const data = await res.json()
    window.quitar_animacion();

    if (!data.estado) {
      // alert(data.errores || "Error en consulta")

      let texto = data.errores || "Error en consulta"
      this.alert_error(texto);

      return null
    }
  
    return data
  }

  async actualizarTransaccion(id, body) {
    window.mostrar_animacion();
    
    const token = this.csrfToken()  
    const res = await fetch(`/transacciones/${id}`, {
      method: "PATCH",
      headers: this.jsonHeaders(token),
      body: JSON.stringify(body)
    })

    const respuestaActualizacion = await res.json()
    window.quitar_animacion();

    if (!respuestaActualizacion.estado) {
      // alert(respuestaActualizacion.errores || "Error en consulta")

      let texto = respuestaActualizacion.errores || "Error en consulta"
      this.alert_error(texto);

      return null
    }
  
    return respuestaActualizacion
  }

  mapearConfirmacion(fields, data) {
    const form_confirmacion = data.data?.datos?.form_confirmacion || {}
  
    fields.forEach(f => {
      if (form_confirmacion[f.tag] != null) {
        f.value = form_confirmacion[f.tag]
        f.readonly = true
      }
    })
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
  
  jsonHeaders(token) {
    return {
      "Content-Type": "application/json",
      "X-CSRF-Token": token
    }
  }

  cancelar() {
    // console.log("Cancelar")
  
    this.reset()
    this.renderCategorias()
  }


  reset() {
    this.servicio = null
    this.servicio_id = null
    this.schema = []
    this.formData = {}
  }



  submitFormulario(e) {
    e.preventDefault()
  
    const form = e.target.closest("form")
    const fd = new FormData(form)

    //const fd = new FormData(e.target)
    const raw = Object.fromEntries(fd.entries())
  
    const payload = {}
    const data = {}
  
    Object.entries(raw).forEach(([key, value]) => {
      let cleanKey = key
    
      if (key.startsWith("payload[")) {
        cleanKey = key.replace("payload[", "").replace("]", "")
        payload[cleanKey] = value
      } else {
        data[key] = value
      }
    })
  
    data.payload = payload
    data.tipo_servicio = this.tipo_servicio
    data.servicio = this.servicio
    data.servicio_id = this.servicio_id
    data.categoria = this.categoria
    data.nivel = this.nivel

    // Option
    // Validar si es por option, que este bloqueado si no ha ingresado nada strpan
    if (e.target.matches('input[type="radio"]')) {
      const monto = e.target.dataset.monto
  
      const cashInput = form.querySelector(
        'input[name="payload[dblCashAmount]"]'
      )
  
      if (cashInput) {
        cashInput.value = monto
        payload.dblCashAmount = monto
      }
    }

   
    // Validar contenido de strPan
    if (!payload.strPan || payload.strPan.trim() === "") {
      return
    }
    

    const errores = this.validar(payload)
  
    if (Object.keys(errores).length > 0) {
      this.pintarErrores(errores)
      return
    }
  
    this.formData = data
    this.upsertTransaccion()
  }


  // 1.1 Validar campos en el FrontEnd
  validar(payload) {
    const errores = {}
  
    this.schema.forEach(c => {
      const v = (payload[c.name] ?? "").toString().trim()
  
      if (c.required && !v) {
        errores[c.name] = "Este campo es requerido"
        return
      }

      // No aplica para options
      if (!c.has_option){
        if (c.type === "number" || c.type === "numeric") {
          const n = Number(v)

          // Corregir bug
          // if has_option {

          // }
    
          if (isNaN(n)) {
            errores[c.name] = "Debe ser numérico"
            return
          }
    
          if (c.min != null && n < c.min) {
            errores[c.name] = `Mínimo ${c.min}`
            return
          }
    
          if (c.max != null && n > c.max) {
            errores[c.name] = `Máximo ${c.max}`
            return
          }
        }
  
        if (c.pattern) {
          const re = new RegExp(c.pattern)
    
          if (!re.test(v)) {
            errores[c.name] = "Formato inválido"
          }
        }
      }
      
    })
  
    return errores
  }

  // 1.2 Mostrar errores
  pintarErrores(errores) {
    // limpia
    this.pantallaTarget.querySelectorAll(".is-invalid")
      .forEach(el => el.classList.remove("is-invalid"))
  
    Object.entries(errores).forEach(([name, msg]) => {
      const wrapper = this.pantallaTarget.querySelector(`[data-field="${name}"]`)
      if (!wrapper) return
  
      const input = wrapper.querySelector("input")
      const feedback = wrapper.querySelector(".invalid-feedback")
  
      input.classList.add("is-invalid")
      feedback.textContent = msg
    })
  }


  // 2. Mostrar confirmacion
  renderConfirmacion() {
    const rows = Object.entries(this.formData)
      .map(([k, v]) => {
    
        // SI ES PAYLOAD -> desglosarlo
        if (k === "payload" && typeof v === "object") {
          return Object.entries(v)
            .map(([pk, pv]) => `
              <div>
                <strong style="text-transform: capitalize;">
                  ${pk.replaceAll("_", " ")}:
                </strong> ${pv}
              </div>
            `).join("")
        }
    
        // resto normal
        return `
          <div>
            <strong style="text-transform: capitalize;">
              ${k.replaceAll("_", " ")}:
            </strong> ${v}
          </div>
        `
      })
      .join("")


    this.pantallaTarget.innerHTML = `
      <h2 class="screen-title">Confirmación</h2>
      <p class="screen-subtitle mb-5">Confirma la siguiente información.</p>
    `
  
    // console.log(rows);

    this.pantallaTarget.innerHTML += `  
      <div class="mb-3">
        ${rows}

        <div><strong>Identificador:</strong> 123</div>
        <div><strong>Fecha Confirmación:</strong> 123</div>
      </div>
    `

    // Botonera
    this.pantallaTarget.innerHTML += `
      <div class="d-flex flex-column justify-content-between mt-5 gap-4">
        <button class="btn btn-primary" data-action="click->transaccion--pago#upsertTransaccion">Aceptar</button>
        <button class="btn btn-danger" data-action="click->transaccion--pago#cancelar">Cancelar</button>
      </div>
    `
  }


  // 3. Registrar Transaccion
  // Crea transaccion si es Nivel 1,  Actualiza transaccion si es nivel 2 (Payload)
  async upsertTransaccion() {
    window.mostrar_animacion();
    let formData = this.formData
    
    if (this.nivel == "1"){
      const token = this.csrfToken()
      const res = await fetch("/transacciones", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({
          transaccion:{
            ...formData,
            prefijo_empresa: this.nombreEmpresaValue.toUpperCase()
          }
        })
      })
    
      const json = await res.json()
      // console.log(json);
      
      // Validar respuesta API
      if (!json.estado) {
        // alert(json.errores?.join(", ") || "Error")

        let texto = json.errores?.join(", ") || "Error"
        this.alert_error(texto);

        // Retornar al inicio
        return
      }
    
      this.transaccionId = json.data.identificador
    

    }else{
      let body = {
        transaccion: {
          payload: formData.payload
        }
      }

      // console.log(body);
      await this.actualizarTransaccion(this.transaccionId, body)
    }
  
    this.procesarTransaccion()
  }

  // 4. Procesar Transaccion
  async procesarTransaccion() {
    window.mostrar_animacion();

    const token = document.querySelector("meta[name='csrf-token']")?.content
    const res = await fetch(`/transacciones/${this.transaccionId}/procesar`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token
      }
    })
  
    const json = await res.json()
    window.quitar_animacion();
    // Validar resultado
    this.renderResultado(json)
  }

  renderResultado(response) {
    const { qr, referencia, identificador, nombre_servicio, fecha_operacion, monto_ingresado, moneda, ...otros } = response.data
    
    const url = `${window.location.origin}/pagos/${identificador}`
    const texto_share = `Boleta de pago: ${url}`
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(texto_share)}`
    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent("Boleta de pago")}`

    
    let qrImg = ""
    if (qr) {
      const src = qr.startsWith("data:")
        ? qr
        : `data:image/svg+xml;base64,${qr}`

      qrImg = `
        <div class="text-center" style="background-color: #FFFFFF; width: 225px; height: 225px; padding: 10px; border-radius: var(--radius-md);">
          <img src="${src}" style="width:200px; height:200px;" />
        </div>
      `
    }


    this.pantallaTarget.innerHTML = `
      <div class="d-flex justify-content-center align-items-center">
        <div class="pill-success">● Transacción lista para Efectuar</div>
      </div>
      
      <div class="d-flex justify-content-center align-items-center mb-3">  
        ${qrImg}
      </div>
    `

    this.pantallaTarget.innerHTML += ` 
      <div class="my-3 d-flex flex-column justify-content-center align-items-center">
        <h2 class="screen-title confirm-title">Monto a pagar</h2>
        <p class="confirm-code">${moneda}.${monto_ingresado}</p>
      </div>

      <div class="d-flex mt-3">
        <button class="btn btn-primary w-100" data-action="click->transaccion--pago#cancelar">Aceptar</button>
      </div>

      <div class="d-flex flex-row gap-2 justify-content-around my-4">
        <a class="btn btn-secondary d-flex align-items-center" href="${whatsappUrl}.pdf" target="_blank">
          <i class="bi bi-whatsapp"></i>
        </a>

        <a class="btn btn-secondary d-flex align-items-center" href="${telegramUrl}.pdf" target="_blank">
          <i class="bi bi-telegram"></i>
        </a>

        <a class="btn btn-secondary d-flex align-items-center" href="${url}.pdf" target="_blank">
          <i class="bi bi-filetype-pdf"></i>
        </a>
      </div>
    `

    // Botonera
    this.pantallaTarget.innerHTML += `
      <div class="form-card mb-3">
        <div class="d-flex justify-content-center">
          <h3 style="margin: 0 0 8px; font-size: 1rem">Resumen de transacción</h3>
        </div>

        <div class="d-flex justify-content-between" style="font-size: 20px;">
          <strong>Fecha:</strong> ${fecha_operacion}
        </div>

        <div class="d-flex justify-content-between" style="font-size: 20px;">
          <strong>Detalle:</strong> ${nombre_servicio}
        </div>

        <div class="d-flex justify-content-between" style="font-size: 20px;">
          <strong>Código de referencia:</strong> ${referencia}
        </div>
      </div>
    `

  }

  bloquearBusqueda(form) {
    const strPan = form.querySelector(
      'input[name="payload[strPan]"]'
    )
  
    if (strPan) {
      strPan.readOnly = true
      strPan.disabled = true
    }
  }


  alert_error(text){
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: text,
      footer: "<a href=\"mailto:callcenter@rxe.com.gt\">Quieres reportar este error?</a>"
    }).then(() => {
      window.location.reload();
    });
  }

  cargar_logo(){
    let logoCopenet = document.getElementById("logo-copenet");
    if (!logoCopenet) return;

    logoCopenet.src = `${this.nombreEmpresaValue}.png` || "copenet-logo.png";
  }

  quitar_logo(){
    let logoCopenet = document.getElementById("logo-copenet");
    if (!logoCopenet) return;

    logoCopenet.src = "copenet-logo.png";
  }

}